{
  "common": {
    "close": "Sluiten",
    "noRecordsFound": "Geen resultaten gevonden",
    "requiredField": "Dit veld is verplicht"
  },
  "header": {
    "languageLabel": "Taal",
    "logoAlt": "ARPM-logo"
  },
  "toast": {
    "success": "Succes",
    "error": "Fout",
    "warning": "Waarschuwing"
  },
  "create": {
    "heroEyebrow": "Afspraak Maken",
    "heroTitle": "Afspraakregistratie",
    "heroSubtitle": "Kies een geschikte datum en tijd om snel uw afspraak te maken.",
    "panelTitle": "Afspraakgegevens",
    "panelSubtitle": "Maak alstublieft de vereiste keuzes",
    "organizationLabel": "Organisatie",
    "facilityLabel": "Locatie",
    "departmentLabel": "Afdeling",
    "doctorLabel": "Dokter",
    "organizationPlaceholder": "Selecteer organisatie",
    "facilityPlaceholder": "Selecteer locatie",
    "departmentPlaceholder": "Selecteer afdeling",
    "doctorPlaceholder": "Selecteer dokter",
    "calendarTitle": "Selecteer datum en tijd",
    "timeHeader": "Beschikbare tijden voor {{date}}",
    "selectableTimes": "Beschikbare Tijden",
    "noAvailableTimes": "Geen beschikbare tijden gevonden.",
    "createButton": "Afspraak Maken",
    "toasts": {
      "missingCoreSelection": "Selectie van organisatie, locatie, afdeling en dokter is verplicht.",
      "missingAppointmentSelection": "Vul alstublieft datum, tijd en dokter in.",
      "unavailableTime": "Het gekozen tijdstip is niet meer beschikbaar. Kies alstublieft een ander tijdstip.",
      "invalidDate": "Selecteer een geldige datum.",
      "invalidTime": "Selecteer een geldige tijd.",
      "created": "Afspraak aangemaakt.",
      "createdFallback": "Afspraak is succesvol aangemaakt.",
      "createError": "Er is een fout opgetreden bij het aanmaken van de afspraak."
    }
  },
  "preparation": {
    "heroEyebrow": "Afspraakregistratie",
    "heroTitle": "Afspraakformulier",
    "heroSubtitle": "Vul uw gegevens volledig in om snel uw afspraak te maken.",
    "metaStepByStep": "Stap voor Stap",
    "metaSecureData": "Veilige Gegevens",
    "panelTitle": "Uw Gegevens",
    "panelSubtitle": "Vul alstublieft alle onderstaande velden in",
    "personalInfoTitle": "Persoonlijke Gegevens",
    "addressInfoTitle": "Adresgegevens",
    "tcLabel": "Patient ID",
    "tcPlaceholder": "Voer patient ID in",
    "tcRequired": "Patient ID is verplicht",
    "tcInvalid": "Controleer alstublieft de juistheid van uw gegevens.",
    "nameLabel": "Voornaam",
    "namePlaceholder": "Voer uw voornaam in",
    "lastNameLabel": "Achternaam",
    "lastNamePlaceholder": "Voer uw achternaam in",
    "birthDateLabel": "Geboortedatum",
    "birthDatePlaceholder": "DD/MM/JJJJ",
    "genderLabel": "Geslacht",
    "male": "Man",
    "female": "Vrouw",
    "phoneLabel": "Telefoonnummer",
    "phonePlaceholder": "5xx xxx xx xx",
    "emailLabel": "E-mail",
    "emailPlaceholder": "voorbeeld@email.com",
    "emailInvalid": "Voer een geldig e-mailadres in",
    "cityLabel": "Plaats",
    "cityPlaceholder": "Selecteer plaats",
    "districtLabel": "District",
    "districtPlaceholder": "Selecteer district",
    "neighborhoodLabel": "Wijk",
    "neighborhoodPlaceholder": "Wijk",
    "streetLabel": "Straat",
    "streetPlaceholder": "Straat",
    "buildingNoLabel": "Huisnummer",
    "buildingNoPlaceholder": "Huisnummer",
    "apartmentNoLabel": "Appartementnummer",
    "apartmentNoPlaceholder": "Appartementnummer",
    "nextButton": "Volgende",
    "checklistTitle": "Voorbereidingscheck",
    "checklistSubtitle": "Verplichte velden worden hieronder gemarkeerd zodra u ze invult.",
    "checklistEmpty": "Er zijn nog geen verplichte velden ingevuld.",
    "fieldLabels": {
      "name": "Voornaam",
      "lastName": "Achternaam",
      "tc": "Patient ID",
      "birthDate": "Geboortedatum",
      "gender": "Geslacht",
      "phone": "Telefoonnummer",
      "email": "E-mail",
      "city": "Plaats",
      "district": "District",
      "neighborhood": "Wijk",
      "street": "Straat",
      "buildingNo": "Huisnummer",
      "apartmentNo": "Appartementnummer"
    },
    "invalidEmailLabel": "E-mail (ongeldig)",
    "invalidBirthDateLabel": "Geboortedatum (ongeldig)"
  },
  "consent": {
    "title": "Toestemmingsinformatie",
    "examination": "Het onderzoek:",
    "paragraph1": "In overleg met onze doktersassistente bepaalt u zelf welke plekjes u onderzocht wilt hebben.",
    "paragraph2": "Wij maken gebruik van een geavanceerd systeem dat goedaardige en kwaadaardige letsels van elkaar kan onderscheiden met een hoge medische validiteit. De resultaten worden beoordeeld door een van onze dermatologen, gespecialiseerd in tele-dermatologie.",
    "singlePrice": "De kosten van een huidkankerscreening zijn € 22,00.",
    "includedTitle": "U krijgt hiervoor:",
    "items": [
      "Intake bij doktersassistente",
      "Huidkankerscreening van een verdachte laesie",
      "Rapportage en diagnose van onze dermatoloog",
      "Informatie over de bescherming van uw huid"
    ],
    "multiplePrice": "De kosten van meerdere huidkankerscreenings zijn € 18,00 per moedervlek.",
    "absenceTitle": "Bij afwezigheid ontvangt u een no-showfactuur. Hiervoor gelden de volgende uitzonderingen:",
    "cancellation48": "Bij een afmelding van 48 uur voor de afspraak: geen kosten.",
    "cancellation24": "Bij een afmelding van 24 uur voor de afspraak: € 15,00 per onderzoek.",
    "sameDay": "Bij een afmelding op de dag van de afspraak of zonder afmelding wordt € 23,50 per onderzoek in rekening gebracht."
  },
  "success": {
    "title": "Bedankt!",
    "subtitle": "Uw inzending is succesvol ontvangen.",
    "message1": "U ontvangt een sms en een e-mail op de contactgegevens die u heeft opgegeven.",
    "message2": "Als u de e-mail niet ontvangt, controleer dan uw spambox."
  },
  "departments": {
    "Cardiology": {
      "label": "Cardiologie",
      "icon": "noun-cardiology-4072383"
    },
    "Nephrology": {
      "label": "Nefrologie",
      "icon": "noun-nephrology-7030227"
    },
    "Urology": {
      "label": "Urologie",
      "icon": "kidney"
    },
    "Pulmonology": {
      "label": "Longgeneeskunde",
      "icon": "lung"
    },
    "Neurology": {
      "label": "Neurologie",
      "icon": "noun-neurology-5594376"
    },
    "Gastroenterology": {
      "label": "Gastro-enterologie",
      "icon": "gastroentology"
    },
    "Endocrinology": {
      "label": "Endocrinologie",
      "icon": "noun-endocrinology-7357860"
    },
    "Hematology": {
      "label": "Hematologie",
      "icon": "noun-hematology-7795354"
    },
    "Rheumatology": {
      "label": "Reumatologie",
      "icon": "noun-rheumatology-8059647"
    },
    "Dermatology": {
      "label": "Dermatologie",
      "icon": "noun-dermatology-6378674"
    },
    "Infectious Diseases": {
      "label": "Infectieziekten",
      "icon": "noun-infectious-disease-7245345"
    },
    "Ophthalmology": {
      "label": "Oogheelkunde",
      "icon": "noun-ophthalmology-7215358"
    },
    "Otolaryngology": {
      "label": "Keel-neus-oorheelkunde",
      "icon": "noun-otolaryngology-4840300"
    },
    "Orthopedics": {
      "label": "Orthopedie",
      "icon": "noun-orthopedics-6516988"
    },
    "Psychiatry": {
      "label": "Psychiatrie",
      "icon": "noun-psychology-6565274"
    },
    "Obstetrics Gynecology": {
      "label": "Gynaecologie en verloskunde",
      "icon": "noun-obstetrics-and-gynecology-1191435"
    },
    "Oncology": {
      "label": "Oncologie",
      "icon": "noun-oncology-2312680"
    },
    "Transplantation": {
      "label": "Transplantatie",
      "icon": "noun-transplant-2526273"
    },
    "Home Care": {
      "label": "Thuiszorg",
      "icon": "noun-home-care-7110960"
    }
  }
}
